import _ from 'lodash'
import React from 'react'
import Slider from 'react-slick'
import styled, { css } from 'styled-components'

import { useViewportSize } from '../../hooks/useViewportSize'
import { Button } from '../Button'
import { brkmax, themeSpace } from '../theme'

import { TabButton } from './styled'

const TabsWrapper = styled.div`
  display: flex;
  flex-direction: row;

  ${brkmax(
    0,
    css`
      flex-direction: column;
    `
  )}
`

const ButtonWrapper = styled.div<{ active?: boolean }>`
  margin-right: ${themeSpace(2)};

  ${({ active }) =>
    !active &&
    css`
      .ant-btn {
        opacity: 0.4;
      }
    `}
`

export type TabInfo<T extends React.Key> = {
  key: T
  title: string
}

type TabsProps<T extends React.Key> = {
  tabs: TabInfo<T>[]
  activeTabKey?: T
  onChange: (tabKey: T) => void
  mobileAsSlider?: boolean
}

export function Tabs<T extends React.Key>({ tabs, activeTabKey, onChange, mobileAsSlider }: TabsProps<T>) {
  const viewportSize = useViewportSize()

  if (mobileAsSlider && (viewportSize?.isMobile || viewportSize?.isTablet)) {
    return (
      <Slider variableWidth infinite={false} edgeFriction={0} swipeToSlide>
        {_.map(tabs, tab => (
          <ButtonWrapper key={tab.key} active={tab.key === activeTabKey}>
            <Button onClick={() => onChange(tab.key)} variant="primary" size="large">
              {tab.title}
            </Button>
          </ButtonWrapper>
        ))}
      </Slider>
    )
  }

  return (
    <TabsWrapper>
      {_.map(tabs, tab => (
        <TabButton key={tab.key} checked={tab.key === activeTabKey} onClick={() => onChange(tab.key)}>
          {tab.title}
        </TabButton>
      ))}
    </TabsWrapper>
  )
}
